import CyberBanner from './CyberBanner';

export default CyberBanner;
